import { PlaylistAddCheck } from '@mui/icons-material';
import { MenuItem, Typography } from '@mui/material';
import { SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO } from '@/dominio/SituacaoConfirmacaoProcessoPautaSessao';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class AlertaConfirmacaoInclusaoPauta extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            quantidade: computed,
            handleClickIcone: action,
            descricao: computed
        });
    }

    get quantidade() {
        return this.store.processosPautaSelecionada.filter((registro) => !registro.confirmadaInclusaoPauta).length;
    }

    handleClickIcone = () => {
        this.store.alterarProcessosEmExibicao('P');
        this.store.alterandoValorFiltro = true;
        this.setTimeout(() => {
            this.store.filtros.reset();
            this.store.filtros.filtroInclusaoConfirmadaPauta.valor =
                SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO.NAO_CONFIRMADO.id;
            this.store.alterandoValorFiltro = false;
        });
    };

    get descricao() {
        return (
            this.quantidade +
            (this.quantidade === 1 ? ' processo' : ' processos') +
            ' sem confirmação de inclusão em pauta/sessão'
        );
    }

    render() {
        if (!this.quantidade || this.quantidade <= 0) {
            return null;
        }

        return (
            <MenuItem
                style={{ display: 'flex', cursor: 'pointer' }}
                onClick={this.handleClickIcone}
            >
                <PlaylistAddCheck style={{ marginRight: '12px', color: 'darkorange', fillOpacity: '1' }} />
                <Typography>{this.descricao}</Typography>
            </MenuItem>
        );
    }
}

export default inject('stores')(observer(AlertaConfirmacaoInclusaoPauta));
